import LoadingComponent from '@/components/LoadingComponent/LoadingComponent'
import { useAtom } from 'jotai'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../providers/auth.provider'
import Login from '../screens/Login/Login'
import { isLogin as isLoginAtom } from '@/jotai/auth.jotai'

function Layout() {
  const { loading } = useAuth()
  const [isLogin] = useAtom(isLoginAtom)
  if (loading) return <LoadingComponent />
  if (isLogin) return <Outlet />
  return <Login />
}

export default Layout
